import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Col } from 'react-bootstrap';
import profile from '../images/profile.png'
import "../../Pages/CommonStyle.css"
import { getReadableDateYYYYMMDD } from "../../utils/utils";

import TextField from '@mui/material/TextField';
import axios from 'axios';

import { toast } from 'react-toastify';
import { base_url } from '../../utils/AxiosConfig';



const EventCreationModal = ({ showJobCardPopUp, closeJobCardModal, clickedDateFromCalendar,callRefreshEventList }) => {

    const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode
    }

    let portNumber = localStorage.getItem('BondTimeportNoData');


    let clickedDateFromCalendarReadable = null

    if (clickedDateFromCalendar) {
        clickedDateFromCalendarReadable = getReadableDateYYYYMMDD(clickedDateFromCalendar)
    }


    const [datePickedForStart, setDatePickedForStart] = useState(null)
    const [datePickedForEnd, setDatePickedForEnd] = useState(null)

    console.log("clickedDateFromCalendar datePickedForStart >>", clickedDateFromCalendar, datePickedForStart)

    const [timePickedForStart, setTimePickedForStart] = useState("09:00")
    const [timePickedForEnd, setTimePickedForEnd] = useState("17:00")




    useEffect(() => {
        console.log("datePickedForStart ", datePickedForStart)
    }, [datePickedForStart])

    const storedLoginUserDataArray = JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];

    let eventOwnerIdFromLocal = ""
    let eventOwnerNameFromLocal = ""

    if (storedLoginUserDataArray.length > 0) {

        console.log("storedLoginUserDataArray ", storedLoginUserDataArray);

        eventOwnerIdFromLocal = storedLoginUserDataArray[0].EMPID
        eventOwnerIdFromLocal = storedLoginUserDataArray[0].Name
        // setFilterId(storedLoginUserDataArray[0].EMPID)
    }

    const initialObject =
    {
        cmpcode: companyCode,
        mode: "ENTRY",
        event_id: "DE9ECBC2-F1DF-40F1-BC67-4BD3087978BD",
        event_name: "",
        event_scheduledon: "2024-12-25 17:54:52",
        event_owner_id: "", 
        evnt_ownder_name: "",
        event_ownder_dept: "",
        created_on: "2024-11-20 17:54:52",
        evnt_creator_name:"KUMARST", //FromLocal login  eventOwnerNameFromLocal
        event_creator_id: "TST001", // from local login eventOwnerIdFromLocal
        devicetoken_employee: "",
        devicetoken_admin: "",
        event_status: ""

    }


    const [objectToSend, setObjectToSend] = useState(initialObject)

    const handleChange = (e) => {

        setObjectToSend({ ...objectToSend, [e.target.name]: e.target.value })
    }

    const handleDatePickerDateStart = (e) => {
        setDatePickedForStart(getReadableDateYYYYMMDD(e.target.value))

        if (datePickedForEnd) {
            if (datePickedForEnd < getReadableDateYYYYMMDD(e.target.value)) {
                setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value))
            }
        } else {
            if (clickedDateFromCalendarReadable < getReadableDateYYYYMMDD(e.target.value)) {
                setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value))
            }
        }

    }


    const handleDatePickerDateEnd = (e) => {


        console.log("date end start", clickedDateFromCalendarReadable, datePickedForStart)

        if (datePickedForStart == null) {

            if (getReadableDateYYYYMMDD(e.target.value) < clickedDateFromCalendarReadable) {
                alert("end date cannot be less than start date")
                setDatePickedForEnd(datePickedForEnd ? datePickedForEnd : clickedDateFromCalendarReadable)
                return
            } else {
                console.log("end date datePickedForStart == null", getReadableDateYYYYMMDD(e.target.value))
                setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value))
            }
        } else {
            if (getReadableDateYYYYMMDD(e.target.value) < datePickedForStart) {
                alert("end date cannot be less than start date")
                setDatePickedForEnd(datePickedForEnd ? datePickedForEnd : clickedDateFromCalendarReadable)
                return
            } else {
                console.log("end date datePickedForStart not null", getReadableDateYYYYMMDD(e.target.value))
                setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value))
            }
        }


    }


    const handleTimePickerDateStart = (e) => {
        setTimePickedForStart(e.target.value)
    }


    const handleTimePickerDateEnd = (e) => {
        setTimePickedForEnd(e.target.value)
    }

    const sendObjectToEventCreationApI = () => {

        if(objectToSend.event_name?.length == 0){
            alert("Please enter event name")
            return
        }

        console.log("date start ", datePickedForStart)
        console.log("date end ", datePickedForEnd)
        console.log("clickedDateFromCalendarReadable ", clickedDateFromCalendarReadable)
        console.log("time start ", timePickedForStart)
        console.log("time end ", timePickedForEnd + ":00")

        let modifiedObjectToSend = null

        if (datePickedForStart) {
            modifiedObjectToSend = { ...objectToSend, event_scheduledon: datePickedForStart + " " + timePickedForStart + ":00" }
        } else {
            modifiedObjectToSend = { ...objectToSend, event_scheduledon: clickedDateFromCalendarReadable + " " + timePickedForStart + ":00" }
        }

        console.log("modifiedObjectToSend ", modifiedObjectToSend)


        const postBody = JSON.stringify([modifiedObjectToSend])

        let apiUrl = `${base_url}/api/CRMEvents`
        console.log("apiurl ", apiUrl)

        axios.post(apiUrl, postBody, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            if (res.status === 200) {
                toast.success('Event Saved!')
                callRefreshEventList()
            }
        }).catch((err) => {
            console.log("err", err)
        })


    }

    return (
        <Modal show={showJobCardPopUp} onHide={closeJobCardModal} centered>
            <Modal.Header closeButton>
                <p>Create Event</p>
            </Modal.Header>
            <Modal.Body >

                <div>
                    <div className='d-flex flex-column'>


                        <div className='d-flex flex-column'>


                            <TextField

                                label="Event Name"
                                variant="standard"
                                name="event_name"
                                onChange={(e) => {
                                    handleChange(e)
                                }}
                            />
                        </div>

                        <label className='mt-3'>Start Date and time </label>

                        {
                            clickedDateFromCalendar &&
                            <div>
                                <div>
                                    <input type='date'
                                        defaultValue={clickedDateFromCalendarReadable}
                                        min={clickedDateFromCalendarReadable}
                                        value={datePickedForStart}
                                        onChange={(e) => handleDatePickerDateStart(e)}></input>
                                    <input type='time'
                                        value={timePickedForStart}
                                        className='ms-1' onChange={(e) => handleTimePickerDateStart(e)} ></input>
                                </div>

                                {/* <label className='mt-2'>End Date and time </label>
                                <div >
                                    <input type='date' defaultValue={clickedDateFromCalendarReadable}
                                        min={datePickedForStart ? datePickedForStart : clickedDateFromCalendarReadable}
                                        value={datePickedForEnd}
                                        onChange={(e) => handleDatePickerDateEnd(e)}></input>
                                    <input type='time'
                                        value={timePickedForEnd}
                                        className='ms-1' onChange={(e) => handleTimePickerDateEnd(e)} ></input>
                                </div> */}
                            </div>
                        }
                    </div>

                    <div className="d-flex justify-content-center mt-4">

                        <button className='btn common-button w-50 text-center' onClick={sendObjectToEventCreationApI}>Save</button>
                    </div>

                </div>

            </Modal.Body>


        </Modal>
    )
}

export default EventCreationModal